import { VideoLevel } from '@edx/graphql/generated';

export const translateVideoLevel = (level: VideoLevel): string =>
  ({
    [VideoLevel.Beginner]: 'Principiante',
    [VideoLevel.Intermediate]: 'Intermedio',
    [VideoLevel.Advanced]: 'Avanzado',
  }[level]);
